import { Toast } from './toast';
import { LocalArrayStore } from '../../../core/stores/local-array-store';

export const toastPool = new LocalArrayStore<Toast>();
